// extracted by mini-css-extract-plugin
module.exports = {"PermissionPanel":"AccessDenied_PermissionPanel__y1oQd","PermissionMessage":"AccessDenied_PermissionMessage__6lkJi","PermissionIcon":"AccessDenied_PermissionIcon__1p6Hv"};